import { baseServiceRequest } from "@apis/baseServiceRequest"
import type {
  IAcceptRetentionOfferRequest,
  IAcceptRetentionOfferResponse,
  IRetentionOffersResponse,
} from "./types"
import type { AxiosResponse } from "axios"
import type { IUserIdParams } from "@commonTypes/user"


export const getRetentionOffers = async (
  account_id: string,
  params: IUserIdParams,
): Promise<AxiosResponse<IRetentionOffersResponse>> => {
  return baseServiceRequest({
    method: "GET",
    url: `/retention/offers/${account_id}`,
    params,
  })
}

export const acceptRetentionOffer = async ({
  account_id,
  offer_code,
  request,
}: {
  account_id: string
  offer_code: string
  request: IAcceptRetentionOfferRequest
}): Promise<IAcceptRetentionOfferResponse> => {
  const response = await baseServiceRequest({
    method: "POST",
    url: `/retention/offers/${offer_code}/accept/${account_id}`,
    data: request,
  })
  return response.data
}
